import React from 'react';

import {
	CategoryList,
	InlineCategoryList,
	InlineCategorySelectorWrapper,
	PlaceholderPill,
	PlaceholderExpandPill,
} from './CategorySelectorStyles.tsx';

export const LoadingCategories = () => (
	<CategoryList data-testid="loading-categories">
		<PlaceholderPill width={120} isDisabled>
			&nbsp;
		</PlaceholderPill>
		<PlaceholderPill width={88} isDisabled>
			&nbsp;
		</PlaceholderPill>
		<PlaceholderPill width={156} isDisabled>
			&nbsp;
		</PlaceholderPill>
		<PlaceholderPill width={88} isDisabled>
			&nbsp;
		</PlaceholderPill>
		<PlaceholderPill width={120} isDisabled>
			&nbsp;
		</PlaceholderPill>
		<PlaceholderPill width={32} isDisabled>
			&nbsp;
		</PlaceholderPill>
	</CategoryList>
);

export const LoadingInlineCategories = () => (
	<InlineCategorySelectorWrapper data-testid="inline-loading-categories" isCollapsed>
		<InlineCategoryList>
			<PlaceholderPill width={88} isDisabled>
				&nbsp;
			</PlaceholderPill>
			<PlaceholderPill width={120} isDisabled>
				&nbsp;
			</PlaceholderPill>
			<PlaceholderPill width={88} isDisabled>
				&nbsp;
			</PlaceholderPill>
			<PlaceholderPill width={120} isDisabled>
				&nbsp;
			</PlaceholderPill>
			<PlaceholderPill width={120} isDisabled>
				&nbsp;
			</PlaceholderPill>
			<PlaceholderPill width={88} isDisabled>
				&nbsp;
			</PlaceholderPill>
			<PlaceholderPill width={120} isDisabled>
				&nbsp;
			</PlaceholderPill>
			<PlaceholderPill width={156} isDisabled>
				&nbsp;
			</PlaceholderPill>
			<PlaceholderExpandPill width={24} isDisabled>
				&nbsp;
			</PlaceholderExpandPill>
		</InlineCategoryList>
	</InlineCategorySelectorWrapper>
);
